import { getProIntl } from '@/locales/proLocales';
import { ProConfigProvider } from '@ant-design/pro-provider';
import { useIntl } from '@umijs/max';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import ruRU from 'antd/locale/ru_RU';
import React from 'react';

/** Ant Design has no tg-TJ locale; map Tajik to Russian. ProComponents otherwise falls back to zh-CN. */
function resolveAntdLocale(locale: string) {
  return locale === 'en-US' ? enUS : ruRU;
}

/**
 * Syncs Ant Design + ProComponents locale with Umi i18n.
 * Must render inside Umi LocaleProvider (useIntl), not in rootContainer.
 */
export const LocaleBridge: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { locale } = useIntl();
  const antdLocale = resolveAntdLocale(locale);
  const proIntl = getProIntl(locale);

  return (
    <ConfigProvider locale={antdLocale}>
      <ProConfigProvider intl={proIntl}>{children}</ProConfigProvider>
    </ConfigProvider>
  );
};

export default LocaleBridge;
